"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Encryption = void 0;
var PEM_HEADER = '-----BEGIN PUBLIC KEY-----';
var PEM_FOOTER = '-----END PUBLIC KEY-----';
function stringToArrayBuffer(byteStr) {
    var bufView = new Uint8Array(byteStr.length);
    for (var i = 0, strLen = byteStr.length; i < strLen; i++) {
        bufView[i] = byteStr.charCodeAt(i);
    }
    return bufView.buffer;
}
var Encryption = /** @class */ (function () {
    function Encryption() {
        this.enable = false;
        this.keyVersion = '';
    }
    Object.defineProperty(Encryption, "supported", {
        // check if support encrypt data
        get: function () {
            var _a, _b;
            var result = 'ArrayBuffer' in self
                && typeof ((_b = (_a = window.crypto) === null || _a === void 0 ? void 0 : _a.subtle) === null || _b === void 0 ? void 0 : _b.importKey) === 'function'
                && typeof window.crypto.getRandomValues === 'function'
                && 'TextEncoder' in self
                && 'Uint8Array' in self
                && typeof window.atob === 'function'
                && typeof window.crypto.subtle.encrypt === 'function';
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Encryption.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.pem) {
                            throw new Error('[MDAP] Public key cannot be empty.');
                        }
                        return [4 /*yield*/, Promise.all([
                                this.initAESKey(),
                                // public key from login
                                this.getPublicKey(this.pem)
                            ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Encryption.prototype.initAESKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, buf;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.crypto.subtle.generateKey({
                                name: 'AES-GCM',
                                length: 256
                            }, true, ['encrypt'])];
                    case 1:
                        _a.privateKey = _b.sent();
                        return [4 /*yield*/, window.crypto.subtle.exportKey('raw', this.privateKey)];
                    case 2:
                        buf = _b.sent();
                        this.privateKeyBuf = new Uint8Array(buf);
                        return [2 /*return*/, this.privateKey];
                }
            });
        });
    };
    Encryption.prototype.getPublicKey = function (pem) {
        return __awaiter(this, void 0, void 0, function () {
            var pemContents, binaryDerString, binaryDer, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pemContents = pem.substring(PEM_HEADER.length, pem.length - PEM_FOOTER.length);
                        binaryDerString = window.atob(pemContents);
                        binaryDer = stringToArrayBuffer(binaryDerString);
                        _a = this;
                        return [4 /*yield*/, window.crypto.subtle.importKey('spki', binaryDer, {
                                name: 'RSA-OAEP',
                                hash: 'SHA-256'
                            }, true, ['encrypt'])];
                    case 1:
                        _a.publicKey = _b.sent();
                        return [2 /*return*/, this.publicKey];
                }
            });
        });
    };
    Encryption.prototype.updateNonce = function () {
        this.nonce = window.crypto.getRandomValues(new Uint8Array(12));
    };
    Encryption.prototype.encryptKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var combineBuff, cipherData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.privateKeyBuf || !this.nonce || !this.publicKey) {
                            return [2 /*return*/, ''];
                        }
                        combineBuff = new Uint8Array(this.privateKeyBuf.length + this.nonce.length);
                        combineBuff.set(this.privateKeyBuf);
                        combineBuff.set(this.nonce, this.privateKeyBuf.length);
                        return [4 /*yield*/, window.crypto.subtle.encrypt({
                                name: 'RSA-OAEP'
                            }, this.publicKey, combineBuff.buffer)];
                    case 1:
                        cipherData = _a.sent();
                        this.cipherKey = btoa(String.fromCharCode.apply(null, new Uint8Array(cipherData)));
                        return [2 /*return*/, this.cipherKey];
                }
            });
        });
    };
    Encryption.prototype.encryptData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var dataStr, enc, encoded, cipherData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.privateKey) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        dataStr = data;
                        if (typeof data !== 'string') {
                            dataStr = JSON.stringify(data);
                        }
                        enc = new TextEncoder();
                        encoded = enc.encode(dataStr);
                        return [4 /*yield*/, window.crypto.subtle.encrypt({
                                name: 'AES-GCM',
                                iv: this.nonce
                            }, this.privateKey, encoded)];
                    case 2:
                        cipherData = _a.sent();
                        return [2 /*return*/, cipherData];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Encryption.prototype.encryt = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var secretKey, cipherData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.publicKey || !this.privateKeyBuf)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.updateNonce();
                        return [4 /*yield*/, this.encryptKey()];
                    case 3:
                        secretKey = _a.sent();
                        return [4 /*yield*/, this.encryptData(data)];
                    case 4:
                        cipherData = _a.sent();
                        return [2 /*return*/, {
                                secretKey: secretKey,
                                cipherData: cipherData
                            }];
                }
            });
        });
    };
    return Encryption;
}());
exports.Encryption = Encryption;
